// assets
import { IconDashboard, IconDeviceAnalytics, IconCode, IconClipboardList, IconChartArcs, IconMessages } from '@tabler/icons-react';

// constant
const icons = {
    IconDashboard,
    IconDeviceAnalytics,
    IconCode,
    IconClipboardList,
    IconChartArcs,
    IconMessages
};

// ==============================|| PHỤC VỤ MODEL (Model Serving) ||============================== //

const modelServing = {
    id: 'model-serving',
    title: 'Phục vụ Model',
    type: 'group',
    children: [
        {
            id: 'model-serving-module',
            title: 'Model Serving',
            type: 'collapse',
            icon: icons.IconDeviceAnalytics,
            children: [
                {
                    id: 'model-serving-overview',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/model-serving/dashboard',
                    breadcrumbs: false
                },
                {
                    id: 'model-serving-deploy',
                    title: 'Deploy Models',
                    type: 'item',
                    url: '/model-serving/deploy',
                    breadcrumbs: false
                },
                {
                    id: 'model-serving-endpoints',
                    title: 'API Endpoints',
                    type: 'item',
                    url: '/model-serving/endpoints',
                    breadcrumbs: false
                },
                {
                    id: 'model-serving-templates',
                    title: 'Templates',
                    type: 'item',
                    url: '/model-serving/templates',
                    breadcrumbs: false
                },
                {
                    id: 'model-serving-monitoring',
                    title: 'Monitoring',
                    type: 'item',
                    url: '/model-serving/monitoring',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default modelServing;
